export const DEACTIVATE_USER = 'DEACTIVATE_USER'



// WEBPACK FOOTER //
// ./src/services/deactivate/constants.js